module.exports = __webpack_public_path__ + "static/media/LegoFloatingHQEXTDeckA0082_design_clean_v001.130e8fe9.png";